import React from "react";
import AuthContext from "../Hooks/AuthContext/AuthContext";

export const useAuth = () => {
    const { hasPermission } = React.useContext(AuthContext);
    return { hasPermission };
};

export const Can = (section: any, permissions: string[]) => {
    const { hasPermission } = useAuth();
    return hasPermission(section, permissions);
};